import { OfferCategoryScreen } from 'app/features/offer/screens'
import {
  OfferCategoryQueryInput,
  OfferCategoryQueryOutput,
  fetchCategoryOffersQuery,
  fetchOfferCategoryQuery,
} from 'app/features/offer/screens/offer-category-screen/queries'
import { addApolloState, initializeApollo } from 'lib/initialize-apollo'
import { withAuthedPage } from 'lib/session'
import { GetServerSideProps } from 'next'

export default function Page(props: any) {
  return <OfferCategoryScreen {...props} />
}

export const getServerSideProps: GetServerSideProps = withAuthedPage(async ({ req, params, query }) => {
  const { slug } = params as { slug: string }
  const user = req?.session?.user
  const draft = !!query?.preview

  const client = initializeApollo({
    token: user?.token,
    previewToken: query?.token as string,
  })

  const offerCategoryData = await client.query<OfferCategoryQueryOutput, OfferCategoryQueryInput>({
    query: fetchOfferCategoryQuery,
    variables: {
      slug,
      draft,
    },
  })

  const offerCategoryId = offerCategoryData?.data?.OfferCategories?.docs?.[0]?.id || ''

  if (offerCategoryId) {
    await client.query({
      query: fetchCategoryOffersQuery,
      variables: {
        category: offerCategoryId,
        page: 1,
        limit: 6,
      },
    })
  }

  return addApolloState(client, {
    props: {
      slug,
      user: user || null,
      preview: draft,
    },
  })
})
